'use strict';

export default class Base {
  constructor() {
    console.log('Base module');
  }
}
